import {defineStore} from "pinia";
import {createBaseStore} from "@/stores/base";

export const useAltarServerStore = defineStore('altarServer', createBaseStore('/messdiener',
        {
            currentSort: [
                {col: 'firstname', sortDir: 'asc'},
                {col: 'lastname', sortDir: 'asc'},
                {col: 'active', sortDir: 'desc'},
            ]
        },
        {
            getPartnersList(altarServer) {
                return altarServer.partners.map(id => this.getPlannameById(id)).join(", ");
            },
            getPlannameById(id) {
                return this.data.find(a => a.id === id)?.planname ?? '';
            },
        },
        {
            getActiveAltarServersIDs: (state) => state.data.filter(a => a.active && a.altarServer).map(a => a.id),
        }
    )
)
